import React from "react";
import DeviceBasedRenderer from "../../../../components/common/DeviceBasedRenderer";
import OrganismDisplayViewEduPreviewDesktop from "./OrganismDisplayViewEduPreviewDesktop";
import OrganismDisplayViewEduPreviewMobile from "./OrganismDisplayViewEduPreviewMobile";

const OrganismDisplayViewEduPreview = (props) => {
  console.log("🎯 기기별 미리보기 라우터 - OrganismDisplayViewEduPreview");

  return (
    <DeviceBasedRenderer
      DesktopComponent={OrganismDisplayViewEduPreviewDesktop}
      MobileComponent={OrganismDisplayViewEduPreviewMobile}
      AndroidComponent={OrganismDisplayViewEduPreviewMobile} // 안드로이드도 모바일 컴포넌트 사용
      IOSComponent={OrganismDisplayViewEduPreviewMobile} // iOS도 모바일 컴포넌트 사용
      {...props} // 모든 props를 하위 컴포넌트에 전달
    />
  );
};

export default OrganismDisplayViewEduPreview;
